export default "__VITE_ASSET__D9ppQp1e__"